export default __webpack_public_path__ + "static/media/sample-single-icon.9bc4dd63.svg";